// src/components/PrivateRoute.jsx
import { Navigate, useParams } from 'react-router-dom';
import { getToken, parseJwt } from '../lib/auth';

export default function PrivateRoute({ children }) {
  const { userId } = useParams();

  const token = getToken();
  const payload = token ? parseJwt(token) : null;
  const loggedIn = !!(payload?.exp && Date.now() < payload.exp * 1000);

  if (!loggedIn) return <Navigate to="/login" replace />;

  if (userId && payload?.sub && userId !== payload.sub) {
    return <Navigate to={`/dashboard/${payload.sub}`} replace />;
  }

  return children;
}
